.root {
  position: relative;
  z-index: 1;
  padding: 2rem 1.5rem;
  border-radius: 1rem;
  background-color: var(--static-background-standard);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: unset;
  max-width: 36.8125rem;
  overflow: hidden;
  .checklist {
    gap: 1.5rem;
    padding: 2.5rem 0;
  }
  @media only screen and (min-width: 1084px) {
    padding: 2.5rem;
    max-height: 832px;
    overflow-y: auto;
  }
}
.header {
  border-bottom: 1px solid var(--static-divider-standard);
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.75rem 0;
}
.rowLarge {
  composes: row;
  padding: 2.5rem 0;
}
.col {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.colLarge {
  composes: col;
  gap: 0.5rem;
}
.divider {
  border-bottom: 1px solid var(--static-divider-standard);
}
.label {
  composes: row;
  justify-content: center;
  padding: 0;
}
.footer {
  padding-top: 1.75rem;
}
.roadmapContainer {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0 2.5rem 0;
  border-bottom: 1px solid var(--static-divider-standard);
}

.roadmapBadgeContainer {
  display: flex;
  padding: 2px 19px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  border: 1px solid var(--sentiment-text-info);
  background: var(--sentiment-background-info);
  color: var(--sentiment-text-info);
}
